import RequestService from './request-service';
import { LAYOUT_NAME } from '../models/enums/layout-const';

export default class MyFavoritesRequestService extends RequestService {
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.myfavorites;
    this.method = 'post';
    const { Culture } = this.$config.defaultHeaders;
    this.postParams = {
      MatchIds: [],
      Culture: Culture,
      NumberOfOddTypes: 3,
      isMultiMarket: APP_SETTINGS.settings.layout === LAYOUT_NAME.US
    };
    this.headers = null;
  }
}
